import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const EmailIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 9C7.20914 9 9 7.20914 9 5C9 2.79086 7.20914 1 5 1C2.79086 1 1 2.79086 1 5C1 7.20914 2.79086 9 5 9Z"
                fill="#23232D"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.99963 5.46191L7.30732 3.46191H2.69193L4.99963 5.46191ZM4.37632 5.24052L4.99963 5.75214L5.61317 5.24052L7.30732 6.69268H2.69193L4.37632 5.24052ZM2.53809 6.53884V3.61576L4.23039 5.0773L2.53809 6.53884ZM7.46116 6.53884V3.61576L5.76886 5.0773L7.46116 6.53884Z"
                fill="white"
            />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const EmailIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 9C7.20914 9 9 7.20914 9 5C9 2.79086 7.20914 1 5 1C2.79086 1 1 2.79086 1 5C1 7.20914 2.79086 9 5 9Z"
                fill="#23232D"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.99963 5.46191L7.30732 3.46191H2.69193L4.99963 5.46191ZM4.37632 5.24052L4.99963 5.75214L5.61317 5.24052L7.30732 6.69268H2.69193L4.37632 5.24052ZM2.53809 6.53884V3.61576L4.23039 5.0773L2.53809 6.53884ZM7.46116 6.53884V3.61576L5.76886 5.0773L7.46116 6.53884Z"
                fill="white"
            />
        </SvgIcon>
    );
};
